import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import {
    closeCancelAutoRenewConfirmDialog,
    renderCancelAutoRenewConfirmDialog,
} from 'reactApp/components/CancelAutoRenewConfirmDialog/CancelAutoRenewConfirmDialog.helpers';
import type { CheckOffer, OutflowOfferWebProps } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers.types';
import { isVkMusicSubscription } from 'reactApp/sections/SubscriptionsPage/SubscriptionsPage.helpers';
import { ESubscriptionModalAction } from 'reactApp/sections/SubscriptionsPage/ui/SubscriptionModal/SubscriptionModal.analytics';

export function checkVkMusicOffer({ subscription }: CheckOffer) {
    return isVkMusicSubscription(subscription);
}

export function* vkMusicOffer({ subscription, continueOutflow, cancelOutflow, sendAnalytics }: OutflowOfferWebProps) {
    const { isTrial } = subscription;
    yield renderCancelAutoRenewConfirmDialog({
        subscription,
        isVkMusic: true,
        isTrial: false,
        onAction() {
            closeCancelAutoRenewConfirmDialog();
            sendAnalytics?.(ESubscriptionModalAction.cancelAutopayment);
            emitAnalyticEvent(AnalyticEventNames.MY_TARIFF_CANCEL_AUTOPAY_TRUE, { isTrial });
            continueOutflow();
        },
        onClose() {
            closeCancelAutoRenewConfirmDialog();
            cancelOutflow();
            sendAnalytics?.(ESubscriptionModalAction.closeCancelAutopayment);
        },
        onSuccess() {
            closeCancelAutoRenewConfirmDialog();
            sendAnalytics?.(ESubscriptionModalAction.notCancelAutopayment);
            emitAnalyticEvent(AnalyticEventNames.MY_TARIFF_CANCEL_AUTOPAY_SAVE, { isTrial });
            cancelOutflow();
        },
    });
}
